import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    size: 10,
    page: 0,
  },
  type: 'notif',
}

export const notifInboxSlice = createAppSlice({
  name: 'notifInbox',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    setType: create.reducer((state, { payload }) => {
      state.type = payload
    }),
  }),
  extraReducers: (builder) => {},
})

export const { setFetchOption, setType } = notifInboxSlice.actions

export default notifInboxSlice.reducer
